import {
  TOGGLE_UPLOAD_MODAL,
  UPLOAD_ART,
  USER_ART,
  USER_LOGOUT,
} from "../actions";
import { DELETE_USER_ART, USER_ART_ENTITY } from "../actions/index";

const initialState = {
  isVisible: false,
  type: "art",
  error: null,
  user_art: {
    error: false,
    loaded: false,
    loading: false,
    entities: [],
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_UPLOAD_MODAL:
      return {
        ...state,
        isVisible: action.payload.isVisible,
        type: action.payload.type || "art",
      };

    case UPLOAD_ART.REQUEST:
      return {
        ...state,
        isUploading: true,
        error: null,
      };

    case UPLOAD_ART.SUCCESS:
      return {
        ...state,
        isUploading: false,
        isVisible: false,
        user_art: {
          ...state.user_art,
          entities: [...state.user_art.entities, action.response],
        },
      };

    case UPLOAD_ART.FAILURE:
      return {
        ...state,
        isUploading: false,
        error: action.error,
      };

    case USER_ART.REQUEST:
      return {
        ...state,
        user_art: {
          ...state.user_art,
          loading: true,
        },
      };

    case USER_ART.SUCCESS:
      return {
        ...state,
        user_art: {
          ...state.user_art,
          loaded: true,
          loading: false,
          entities: Array.isArray(action.response) ? action.response : [], // an empty response does not come back as an array
        },
      };

    case USER_ART_ENTITY.SUCCESS:
      let singleArtEntityState = {
        ...state,
        user_art: {
          ...state.user_art,
        },
      };
      let entities = [],
        replaced = false;
      for (
        let i = 0, len = singleArtEntityState.user_art.entities.length;
        i < len;
        i++
      ) {
        if (
          action.response.id === singleArtEntityState.user_art.entities[i].id
        ) {
          entities.push(action.response);
          replaced = true;
        } else {
          entities.push(singleArtEntityState.user_art.entities[i]);
        }
      }

      if (!replaced) {
        entities.push(action.response);
      }

      singleArtEntityState.user_art.entities = entities;
      return singleArtEntityState;

    case DELETE_USER_ART.SUCCESS:
      //delete all user art and rely on the fetchUserArtEntities() saga to repopulate
      return {
        ...state,
        user_art: {
          ...state.user_art,
          entities: [],
        },
      };

    case USER_ART.FAILURE:
      return {
        ...state,
        user_art: {
          ...state.user_art,
          loaded: true,
          loading: false,
          error: action.error,
        },
      };
    case USER_LOGOUT.SUCCESS:
      return {
        ...state,
        user_art: {
          ...state.user_art,
          loaded: false,
          loading: false,
          entities: [],
        },
      };

    default:
      return state;
  }
}
